var map = {
	"./Facebook.svg": 297,
	"./Insta.svg": 296,
	"./Linkedin.svg": 300,
	"./Twitter.svg": 298,
	"./Youtube.svg": 299,
	"./bncimagenes.png": 513,
	"./bonificaciones.png": 514,
	"./calendar.svg": 304,
	"./clientes.svg": 515,
	"./download.svg": 516,
	"./editar.svg": 305,
	"./editar_black.svg": 306,
	"./excel-logo.png": 307,
	"./manualmarca.png": 517,
	"./menu.svg": 303,
	"./precios.png": 518,
	"./presupuesto.svg": 519,
	"./vendedores.svg": 520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;